import React from 'react';
import { RecomendedControlsSlideId } from 'src/api/types/wizard';
import { FrameworkSlide } from './FrameworkSlide';
import { SlideConfig } from '../types';
import { ScenariosSlide } from './ScenariosSlide';
import { LinkSlide } from './LinkSlide';

export const addScenariosSlides = [
  {
    title: 'Help Us Understand Your Organisation: Scenarios',
    component: ScenariosSlide,
    id: RecomendedControlsSlideId.scenarios,
  },
];

export const addControlsSlides: SlideConfig[] = [
  // {
  //   title: 'Help Us Understand Your Organisation: Controls',
  //   subTitle: `To provide accurate suggestions for controls, we need to gather more information about your organisation. Your responses will help us suggest relevant controls. If you need to gather information to answer the questions, you can leave and return to the wizard as many times as required. Approximate values are fine and can be changed or refined over time. You can save your answers and exit at any time.`,
  //   component: FrameworkSlide,
  //   id: RecomendedControlsSlideId.controls,
  // },
  {
    title: 'Link Controls',
    component: LinkSlide,
    id: RecomendedControlsSlideId.link,
  },
];
